import {defineStore} from 'pinia'

// You can name the return value of `defineStore()` anything you want,
// but it's best to use the name of the store and surround it with `use`
// and `Store` (e.g. `useUserStore`, `useCartStore`, `useProductStore`)
// the first argument is a unique id of the store across your application
export const usePackageStore = (uuid) => defineStore(`packages/${uuid}`, {
    state: () => {
        return ({
            uuid,
            width: null,
            height: null,
            length: null,
            weight: null,
            distance_unit: 'in',
            mass_unit: 'lb',
            value: null,
            description: '',
            country: '',
        })
    },

    getters: {
        name: ({length, width, height, weight, value, description, country}) => {
            const weightWithUnit = weight ? `${weight}lbs` : ''
            const valueWithUnit = value ? ` $${value}` : ''
            return `<span style="white-space: nowrap;">${length ?? ''}L x ${width ?? ''}W x ${height ?? ''}H<br> <span style="font-size: 12px; text-overflow: ellipsis; overflow: hidden">${valueWithUnit} ${weightWithUnit} ${country ?? ''} ${description ?? ''}</span></span>`
        },
    },
})()
